/**
 * MaintenanceBanner - Displays a dismissible amber banner when content gating is bypassed
 * Only visible to super_admin users
 */
import { useState } from 'react';
import { useSystemKillSwitches } from '@/hooks/useSystemKillSwitches';
import { useUserRole } from '@/hooks/useUserRole';
import { X } from 'lucide-react';
import { useLocalizations } from '@/hooks/useLocalizations';

const DISMISS_KEY = 'maintenance-banner-dismissed';

export function MaintenanceBanner() {
  const { bypassContentGating, isLoading } = useSystemKillSwitches();
  const { isSuperAdmin } = useUserRole();
  const { lCommon } = useLocalizations();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === 'true');

  if (isLoading || !bypassContentGating || dismissed || !isSuperAdmin) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, 'true');
    setDismissed(true);
  };

  return (
    <div className="bg-amber-500 text-amber-950 px-4 py-2 text-center text-sm font-medium relative">
      Content access restrictions are temporarily disabled for maintenance.
      <button
        onClick={handleDismiss}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-amber-600/30 rounded"
        aria-label={lCommon('maintenance_banner.dismiss.aria_label', { defaultValue: 'Dismiss banner' })}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
